import presenterModeMixin from '../../mixins/PresenterMode';

export default {
	mixins: [presenterModeMixin],
	data() {
		return {
			libraryId: null,
			contentId: null,
			stream: null,
			screenSharingWindow: null,
			windowCheckInterval: null,
			speakerNotesWindow: null,
			audienceNotesWindow: null,
			isSpeakerNotesWindowActive: false,
			isAudienceNotesWindowActive: false
		};
	},
	created() {
		this.initPresenterModeChannel();

		this.libraryId = this.vm.value.header.metadata.library_id;
		this.contentId = this.vm.value.header.metadata.content_id;

		window.addEventListener('beforeunload', () => {
			if (this.isScreenSharingActive) this.stopScreenSharing();

			if (this.isDuplicateScreenActive && this.isInstructorOrStudentWindowActive) this.stopDuplicateScreen();

			this.closeSpeakerNotesWindow();
			this.closeAudienceNotesWindow();
		});
	},
	methods: {
		canStartPresenterModeActivity() {
			return this.vm.canStartPresenterModeActivity;
		},
		handlePresenterModeChannelEvents() {
			this.presenterModeChannel.onmessage = event => {
				const { action, contentId: id, slideId, fontSize, isStudentWindow } = event.data;

				if (this.contentId != id) return;

				if (action === this.constants.SPEAKER_NOTES_READY) {
					this.updateSpeakerNotes();
					this.updateFontSizeNotes();
				}

				if (action === this.constants.AUDIENCE_NOTES_READY) {
					this.updateAudienceNotes();
					this.updateFontSizeNotes();
				}

				if (action === this.constants.SELECT_SLIDE && this.isInstructorOrStudentWindowActive) {
					this.navigation.selectSlideById(slideId);
				}

				if (action === this.constants.UPDATE_FONT_SIZE_NOTES_WINDOW && this.isStudentWindowActive === isStudentWindow) {
					this.notesFontSize = fontSize;
				}
			};
		},
		startDuplicateScreen(route) {
			this.presenterModeChannel.postMessage({ action: this.constants.START_DUPLICATE_SCREEN });

			this.setInstructorWindowActive(true);
			this.openDuplicateScreenWindow(route);
		},
		stopDuplicateScreen() {
			this.presenterModeChannel.postMessage({ action: this.constants.STOP_DUPLICATE_SCREEN });
		},
		async startScreenSharing() {
			const displayMediaOptions = {
				video: {
					cursor: 'never'
				}
			};

			try {
				this.stream = await navigator.mediaDevices.getDisplayMedia(displayMediaOptions);

				this.presenterModeChannel.postMessage({ action: this.constants.START_SCREEN_SHARING });

				this.setScreenSharingActive(true);
				this.openScreenSharingWindow();
				this.setRemoteVideoStream();
			} catch (error) {
				this.setScreenSharingActive(false);
			}
		},
		setRemoteVideoStream() {
			const remoteVideo = this.screenSharingWindow.document.getElementById('remoteVideo');
			remoteVideo.srcObject = this.stream;

			const [track] = this.stream.getVideoTracks();
			track.addEventListener('ended', () => {
				this.stopScreenSharing();
			});
		},
		stopScreenSharing() {
			if (this.stream) {
				this.stream.getTracks().forEach(track => track.stop());
				this.stream = null;
			}

			if (this.windowCheckInterval) {
				clearInterval(this.windowCheckInterval);
				this.windowCheckInterval = null;
			}

			this.presenterModeChannel.postMessage({ action: this.constants.STOP_SCREEN_SHARING });

			this.closeSpeakerNotesWindow();
			this.closeScreenSharingWindow();
			this.setScreenSharingActive(false);
		},
		openSpeakerNotesWindow() {
			this.checkIsSpeakerNotesWindowActive();

			if (!this.isSpeakerNotesWindowActive) {
				this.speakerNotesWindow = window.open(
					`/content/${this.libraryId}/${this.contentId}/speaker-notes${this.isStudentWindowActive ? '/student' : ''}`,
					'_blank',
					'width=400,height=800'
				);

				this.isSpeakerNotesWindowActive = true;
			}
		},
		closeSpeakerNotesWindow() {
			this.checkIsSpeakerNotesWindowActive();

			if (this.isSpeakerNotesWindowActive) {
				this.isSpeakerNotesWindowActive = false;
				this.speakerNotesWindow.close();
			}
		},
		openAudienceNotesWindow() {
			this.checkIsAudienceNotesWindowActive();

			if (!this.isAudienceNotesWindowActive) {
				this.audienceNotesWindow = window.open(
					`/content/${this.libraryId}/${this.contentId}/audience-notes${this.isStudentWindowActive ? '/student' : ''}`,
					'_blank',
					'width=400,height=800'
				);

				this.isAudienceNotesWindowActive = true;
			}
		},
		closeAudienceNotesWindow() {
			this.checkIsAudienceNotesWindowActive();

			if (this.isAudienceNotesWindowActive) {
				this.isAudienceNotesWindowActive = false;
				this.audienceNotesWindow.close();
			}
		},
		openScreenSharingWindow() {
			if (!this.screenSharingWindow || this.screenSharingWindow.closed) {
				this.screenSharingWindow = window.open('', '_blank', 'width=800,height=600');
				this.screenSharingWindow.document.write(`
          <html>
            <head><title>Presentation</title></head>
            <body style="margin:0; overflow: hidden">
              <video id="remoteVideo" autoplay playsinline muted style="width:100%; height:100%; object-fit:contain; background-color: black"></video>
            </body>
          </html>
        `);

				this.monitorScreenSharingWindow();
			}
		},
		closeScreenSharingWindow() {
			if (this.screenSharingWindow && !this.screenSharingWindow.closed) {
				this.screenSharingWindow.close();
			}
		},
		monitorScreenSharingWindow() {
			this.windowCheckInterval = setInterval(() => {
				if (this.screenSharingWindow.closed) {
					this.stopScreenSharing();
				}
			}, 500);
		},
		openDuplicateScreenWindow(route) {
			const currentPath = route.path;
			const urlToOpen = `${currentPath}/presenter-mode`;

			window.open(urlToOpen, '_blank');
		},
		updateSpeakerNotes() {
			this.presenterModeChannel.postMessage({
				action: this.constants.UPDATE_SPEAKER_NOTES,
				notes: this.navigation.selectedSlide.notes.speaker,
				contentId: this.contentId
			});
		},
		updateAudienceNotes() {
			this.presenterModeChannel.postMessage({
				action: this.constants.UPDATE_AUDIENCE_NOTES,
				notes: this.navigation.selectedSlide.notes.audience,
				contentId: this.contentId
			});
		},
		updateFontSizeNotes() {
			this.presenterModeChannel.postMessage({
				action: this.constants.UPDATE_FONT_SIZE_NOTES,
				fontSize: this.notesFontSize,
				contentId: this.contentId,
				isStudentWindow: this.isStudentWindowActive
			});
		},
		updateSelectedSlide() {
			if (!this.isInstructorOrStudentWindowActive) return;

			this.presenterModeChannel.postMessage({
				action: this.constants.SELECT_SLIDE,
				contentId: this.contentId,
				slideId: this.navigation.selectedSlide.id
			});
		},
		checkIsSpeakerNotesWindowActive() {
			this.isSpeakerNotesWindowActive = this.speakerNotesWindow && !this.speakerNotesWindow.closed;
		},
		checkIsAudienceNotesWindowActive() {
			this.isAudienceNotesWindowActive = this.audienceNotesWindow && !this.audienceNotesWindow.closed;
		}
	},
	computed: {
		isInstructorOrStudentWindowActive() {
			return this.isStudentWindowActive || this.isInstructorWindowActive;
		},
		isSpeakerOrAudienceNotesWindowActive() {
			return this.isSpeakerNotesWindowActive || this.isAudienceNotesWindowActive;
		}
	},
	watch: {
		'navigation.selectedSlide': {
			handler() {
				if (this.isSpeakerNotesWindowActive) this.updateSpeakerNotes();
				if (this.isAudienceNotesWindowActive) this.updateAudienceNotes();
				if (this.isDuplicateScreenActive) this.updateSelectedSlide();
			}
		},
		isDuplicateScreenActive: {
			handler() {
				if (!this.isDuplicateScreenActive) this.setInstructorWindowActive(false);
			}
		},
		notesFontSize: {
			handler() {
				if (this.isSpeakerOrAudienceNotesWindowActive) this.updateFontSizeNotes();
			}
		}
	}
};
